<script>
import { Pie } from 'vue-chartjs'
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels'

export default {
  extends: Pie,
  props: {
    labels: {
      type: Array,
      required: true,
    },
    datasets: {
      type: Array,
      required: true,
    },
    options: {
      type: Object,
      default: () => {}
    },
    enableDatalabels: {
      type: Boolean,
      default: false
    },
  },
  mounted() {
    if (this.enableDatalabels) {
      this.addPlugin(ChartJSPluginDatalabels)
    }
    this.renderChart(
      {
        labels: this.labels,
        datasets: this.datasets,
      },
      {
        ...{
          maintainAspectRatio: true,
          responsive: true,
          legend: {
            position: 'bottom',
          },
        },
        ...this.options
      }
    )
  },
}
</script>